import React, { useState } from 'react';

const TILE_PALETTES = [
  ['#FF8A3D', '#E85D4C'],
  ['#4C8DFF', '#6A4CFF'],
  ['#20C997', '#0CA678'],
  ['#F06595', '#E8590C'],
  ['#FCC419', '#F08C00'],
  ['#9775FA', '#5C7CFA'],
];

const tilePalette = (id: string) => {
  let index = 0;
  for (let i = 0; i < id.length; i += 1) {
    index = (index + id.charCodeAt(i)) % TILE_PALETTES.length;
  }
  return TILE_PALETTES[index];
};

interface ArcadeGamePosterProps {
  id: string;
  title: string;
  iconUrl?: string;
  fontSize?: number;
}

const ArcadeGamePoster: React.FC<ArcadeGamePosterProps> = ({ id, title, iconUrl, fontSize = 40 }) => {
  const [failed, setFailed] = useState(false);
  const [from, to] = tilePalette(id || title);
  const initial = (title || '?').trim().charAt(0) || '?';
  const showImage = Boolean(iconUrl) && !failed;

  return (
    <div
      style={{
        position: 'relative',
        width: '100%',
        height: '100%',
        backgroundColor: to,
        backgroundImage: `linear-gradient(160deg, ${from}, ${to})`,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: 'white',
        overflow: 'hidden',
      }}
    >
      {showImage ? (
        <img
          src={iconUrl}
          alt=""
          onError={() => setFailed(true)}
          style={{
            position: 'absolute',
            inset: 0,
            width: '100%',
            height: '100%',
            objectFit: 'cover',
          }}
        />
      ) : (
        <span
          style={{
            fontSize: `${fontSize}px`,
            fontWeight: 800,
            letterSpacing: '-0.04em',
            textShadow: '0 8px 24px rgba(0,0,0,0.25)',
          }}
        >
          {initial}
        </span>
      )}
    </div>
  );
};

export default ArcadeGamePoster;
